import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBreakthrough = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 38,
	height: 100,
	viewBox: "0 0 38.0 100.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 25,
			width: 4,
			height: 50,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 34,
			y: 25,
			width: 4,
			height: 50,
			fill: "#000000",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 0,
			height: 0,
			fill: "#000000",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 4.0 0.0 L 4.0 35.0 L 34.0 35.0 L 34.0 0.0 M 4.0 100.0 L 4.0 65.0 L 34.0 65.0 L 34.0 100.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 4.0 10.0 L 14.0 0.0 M 4.0 20.0 L 24.0 0.0 M 4.0 30.0 L 34.0 0.0 M 9.0 35.0 L 34.0 10.0 M 19.0 35.0 L 34.0 20.0 M 29.0 35.0 L 34.0 30.0 M 4.0 75.0 L 14.0 65.0 M 4.0 85.0 L 24.0 65.0 M 4.0 95.0 L 34.0 65.0 M 9.0 100.0 L 34.0 75.0 M 19.0 100.0 L 34.0 85.0 M 29.0 100.0 L 34.0 95.0",
			fill: "#000000",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgBreakthrough;
